import { render, staticRenderFns } from "./playerOrderofMerit.vue?vue&type=template&id=1d2da966&scoped=true"
import script from "./playerOrderofMerit.vue?vue&type=script&lang=js"
export * from "./playerOrderofMerit.vue?vue&type=script&lang=js"
import style0 from "./playerOrderofMerit.vue?vue&type=style&index=0&id=1d2da966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2da966",
  null
  
)

export default component.exports